import { render, staticRenderFns } from "./Cashbox.vue?vue&type=template&id=15fa2ca7&"
import script from "./Cashbox.vue?vue&type=script&lang=js&"
export * from "./Cashbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports